import SidebarMobileItem from "./SidebarMobileItem";
import {userRole} from "@/helpers/h";
import {cx} from "class-variance-authority";
import {
  LayoutDashboard,
  Briefcase,
  FileText,
  Settings,
  RotateCcw,
  ClipboardList,
  BarChart3,
  Truck,
} from "lucide-react";

export default function SidebarMobile() {
  const role = userRole();

  return (
    <div className="order-2 bg-white border-t border-gray-200 shadow-lg">
      <div
        className={cx(
          "px-3 py-3 overflow-x-auto",
          "flex items-center gap-2",
          // role === "service_engineer" ? "justify-start" : "justify-center"
          "justify-center"
        )}
      >
        {role === "cash_in_transit" && (
          <>
            <SidebarMobileItem
              icon={<LayoutDashboard className="w-5 h-5" />}
              link="/cit/dashboard"
              title="Dashboard"
            />
            <SidebarMobileItem
              icon={<Briefcase className="w-5 h-5" />}
              link="/cit/sot/all"
              title="All Ticket"
            />
          </>
        )}
        {role === "first_level_maintenance" && (
          <>
            <SidebarMobileItem
              icon={<LayoutDashboard className="w-5 h-5" />}
              link="/flm/dashboard"
              title="Dashboard"
            />
            <SidebarMobileItem
              icon={<Briefcase className="w-5 h-5" />}
              link="/flm/sot/all"
              title="All Ticket"
            />
          </>
        )}
        {role === "comm_vendor" && (
          <>
            <SidebarMobileItem
              icon={<LayoutDashboard className="w-5 h-5" />}
              link="/cv/dashboard"
              title="Dashboard"
            />
            <SidebarMobileItem
              icon={<Briefcase className="w-5 h-5" />}
              link="/cv/sot/all"
              title="All Ticket"
            />
          </>
        )}
        {role === "service_engineer" && (
          <>
            <SidebarMobileItem
              icon={<LayoutDashboard className="w-5 h-5" />}
              link="/service-engineer/dashboard"
              title="Dashboard"
            />
            <SidebarMobileItem
              icon={<Briefcase className="w-5 h-5" />}
              dropUp={true}
              title="Job Fulfillment"
              links={[
                {
                  link: "/service-engineer/jf/maintenance/corrective",
                  title: "CM",
                },
                {
                  link: "/service-engineer/jf/maintenance/preventive",
                  title: "PM",
                },
                {
                  link: "/service-engineer/jf/maintenance/other",
                  title: "OTH",
                },
              ]}
            />
            <SidebarMobileItem
              icon={<FileText className="w-5 h-5" />}
              link="/service-engineer/sot/leave"
              title="Job Report"
            />
            <SidebarMobileItem
              icon={<Settings className="w-5 h-5" />}
              link="/service-engineer/sot/part-list"
              title="Part List"
            />
            <SidebarMobileItem
              icon={<RotateCcw className="w-5 h-5" />}
              link="/service-engineer/sot/part-return"
              title="Part Return"
            />
            <SidebarMobileItem
              icon={<ClipboardList className="w-5 h-5" />}
              link="/service-engineer/sot/part-request"
              title="Part Request"
            />
          </>
        )}
        {role === "manager" && (
          <>
            <SidebarMobileItem
              icon={<BarChart3 className="w-5 h-5" />}
              link="/manager/service_engineer/dashboard"
              title="SD Dashboard"
            />
            <SidebarMobileItem
              icon={<Truck className="w-5 h-5" />}
              link="/manager/logistic/dashboard"
              title="LOG Dashboard"
            />
          </>
        )}
      </div>
    </div>
  );
}
